<script>
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import filter from 'lodash/filter'

export default {
  page: {
    title: 'Policy',
    meta: [{ name: 'description', content: 'Policy' }],
  },
  data() {
    return {
      activeNames: [''],
    }
  },
  computed: {
    ...mapState('common', { constants: (state) => state.constants }),
    ...mapState('common', { config: (state) => state.config }),
    c_display_terms() {
      return filter(this.config.terms, { display: 'Y' })
    },
  },
  methods: {
    fromPairs,
  },
}
</script>

<template>
  <div class="main">
    <!-- main 시작 -->
    <div class="policy-wrap">
      <div class="container">
        <el-collapse v-model="activeNames">
          <template v-for="list in c_display_terms">
            <el-collapse-item
              :key="list.type"
              :title="fromPairs(constants.service.term_types)[list.type]"
              :name="list.type"
            >
              <PerfectScrollbar class="scroll">
                <div class="content" v-html="list.content"> </div>
              </PerfectScrollbar>
            </el-collapse-item>
          </template>
          <el-collapse-item title="Privacy Policy">
            <PerfectScrollbar class="scroll">
              <div class="content">
                <p style="line-height:107%;margin:0in 0in 8pt;text-align:center;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:16.0pt;"><span style="line-height:107%;"><strong>Privacy Policy</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:center;word-break:break-all;">
    &nbsp;
</p>
<div>
    <figure class="table" style="float:left;">
        <table cellspacing="0" cellpadding="0" hspace="0" vspace="0">
            <tbody>
                <tr>
                    <td style="padding:0in;vertical-align:top;" align="left">
                        <p style="line-height:67.15pt;margin:0in 0in .0001pt;page-break-after:avoid;text-align:left;vertical-align:baseline;word-break:break-all;" align="left">
                            <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:75.0pt;"><strong>O</strong></span>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </figure>
</div>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>neWorldPay, (hereinafter referred to as the 'Company') has the following policy to protect users' personal information and rights and interests in accordance with the Personal Information Protection Act and to smoothly handle users' conflicts related to personal information.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>This Privacy Policy applies to all services of the company's website, and may differ from services provided on other websites. When the company revises the personal information processing policy, it is notified through the website notice (or individual notice).</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company's privacy policy contains the following contents.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1. Consent to collection of personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2. Purpose of collection and use of personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>3. Items of personal information collected and method of collection</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>4. Retention and use period of collected personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5. Sharing and provision of collected personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>6. Matters concerning the management of the user's own personal information (view, correction, deletion, etc.)</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>7. Matters concerning the operation of cookies</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>8. Technical-management measures related to personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>9. Matters concerning the collection of opinions and processing of requests related to personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 1. Consent to collection of personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>&nbsp;</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company establishes that a procedure for users to click the "agree" button or "cancel" button on the contents of the company's privacy policy or terms of use, and if they click the "agree" button, they agree to the collection of personal information as they are considered</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 2. Purpose of collection and use of personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>&nbsp;</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>"Personal information" means information about a living individual that can identify the individual by the name, resident registration number, etc. (including those that can be easily combined and identified).</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Most of the services provided can be used at any time without separate user registration. However, the company collects personal information of users to provide services for safe transaction of digital assets and storage and management of assets.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company does not disclose the user's personal information without the user's prior consent, and the collected information is used as follows.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-1 More useful services can be developed based on the personal information provided by users. The company prioritizes the services to be developed more efficiently based on the personal information provided by existing users to the company when developing new services or contents, and the company can reasonably select and provide the contents that users need. can.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-2. The company notifies users of the details of personal information collected by the company, how to use it, information to be provided or entrusted, and how to destroy it through the personal information processing policy.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-3. Users have legal rights regarding their personal information, including the right to self-determination of personal information. And the Privacy Policy guides you on how to exercise your legal rights regarding your personal information.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-4. It also guides you on how to prevent personal information infringement accidents and recover damage when an accident has already occurred.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 3 Items of Personal Information to be Collected and Method of Collection</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company receives essential information for providing services online when users sign up as members to use member services. The essential information received when signing up for membership is name, resident registration number, e-mail address, address, phone number, passport information, etc. In addition, additional personal information may be requested according to the member's transaction level.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 4. Personal information processing and retention period</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Personal information is processed and retained within the personal information retention/use period agreed upon when collecting personal information from the information subject, and, in principle, is destroyed without delay when the purpose of processing personal information is achieved.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>- Records on contract or subscription withdrawal: 5 years</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>- Records on payment and supply of goods: 5 years</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>- Records on consumer complaints or dispute handling: 3 years</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 5. Sharing and provision of collected personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company uses users' personal information within the scope notified in "B. Purpose of collection and use of personal information", and uses it beyond the scope provided without the user's prior consent or, in principle, discloses the user's personal information to the outside world. Do not. However, the following cases are exceptions.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5-1 When users have agreed to disclosure in advance</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5-2 When it is necessary for the settlement of charges for service provision</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5-3 In case of violating the terms of use or policies such as the service terms and conditions posted on the website or other member services</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5-4 If there are sufficient grounds to believe that personal information should be disclosed in order to take legal action against others by causing mental or material harm to others using the service</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>5-5 If there are other parts required by law</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 6 Matters concerning the management of the user's own personal information (view, correction, deletion, etc.)</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>6-1. Users can use the company homepage at any time to view or modify their registered personal information according to the procedure, and may request cancellation of membership.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>6-2. The company immediately handles the user's request for member information management through legal procedures.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 7. Matters concerning the operation of cookies</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>&nbsp;</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>In order to provide customized services tailored to users, the company uses 'cookies' that store and retrieve users' information from time to time. Cookies are a small amount of information that the server (HTTP) used to run the website sends to the user's computer browser, and is sometimes stored on the hard disk of the user's IT equipment.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 8. Technical-management measures related to personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>8-1 The company has the following measures to prevent money laundering and illegal transactions through theft of personal information.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company is doing its best to prevent leakage or damage of members' personal information due to hacking or computer viruses. In preparation for damage to personal information, data is backed up from time to time, the latest vaccine program is used to prevent leakage or damage of personal information or data of users, and personal information is safely transmitted over the network through encryption algorithms. In addition, we use an intrusion prevention system to control unauthorized access from outside, and we strive to equip all possible technical devices to ensure systemic stability.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>8-2 Users' all personal information is thoroughly protected by passwords. Only the member knows the password of the member ID (ID), and confirmation and change of personal information can only be done by the person who knows the password. Therefore, users should not disclose their password to anyone.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 9. Matters concerning collection of opinions and processing of requests related to personal information</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:left;word-break:break-all;" align="left">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company collects the opinions of users in relation to personal information protection and prepares all procedures and methods to handle complaints. Users can report complaints by phone or e-mail by referring to the customer center information specified below, and the company will provide prompt and sufficient answers to users' reports.</strong></span></span>
</p>
              </div>
            </PerfectScrollbar>
          </el-collapse-item>
          <el-collapse-item title="Guidance on Personal Information Dispute Procedures">
            <PerfectScrollbar class="scroll">
              <div class="content">
                <p style="line-height:107%;margin:0in 0in 8pt;text-align:center;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:16.0pt;"><span style="line-height:107%;"><strong>Guidance on Personal Information Dispute Procedures</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<div>
    <figure class="table" style="float:left;">
        <table cellspacing="0" cellpadding="0" hspace="0" vspace="0">
            <tbody>
                <tr>
                    <td style="padding:0in;vertical-align:top;" align="left">
                        <p style="line-height:67.15pt;margin:0in 0in .0001pt;page-break-after:avoid;text-align:justify;vertical-align:baseline;word-break:break-all;">
                            <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:75.0pt;"><strong>W</strong></span>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </figure>
</div>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>hen there is a dispute between the parties in relation to the processing of personal information, anyone who wants to mediate the dispute can apply, and the contents of the application include the right to request access to personal information, as well as the cessation of violations of laws and regulations, claims for compensation for damages, Active exercise of rights, such as the right to request correction and the right to delete, is also included. The same applies to the collective dispute mediation described below.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The company's dispute process proceeds in the following order.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1. Application and acceptance of disputes</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Dispute mediation regarding personal information can be requested by the applicant in person or by proxy through the website, mail, etc., and when the dispute mediation case is received, the applicant and the other party are notified of the reception.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2. Receipt and notification of application cases</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Dispute mediation regarding personal information can be requested by the applicant in person or by proxy through the website, mail, etc., and when the dispute mediation case is received, the applicant and the other party are notified of the reception.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>3. Fact-checking and listening to the opinions of the parties</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>The person in charge of the case conducts a fact-finding investigation on the dispute mediation case by collecting data using various means such as telephone, mail, and e-mail.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>4. Recommendation of agreement before mediation</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Prior to mediation, the Personal Information Dispute Mediation Committee may recommend an agreement so that the dispute can be resolved amicably through voluntary efforts between the parties, and if an agreement is reached between the parties through the recommendation of agreement, the case is closed.</strong></span></span>
</p>
              </div>
            </PerfectScrollbar>
          </el-collapse-item>
          <el-collapse-item title="Provisions on Limitation of Liability">
            <PerfectScrollbar class="scroll">
              <div class="content"><p style="line-height:107%;margin:0in 0in 8pt;text-align:center;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:16.0pt;"><span style="line-height:107%;"><strong>Provisions on Limitation of Liability</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<div>
    <figure class="table" style="float:left;">
        <table cellspacing="0" cellpadding="0" hspace="0" vspace="0">
            <tbody>
                <tr>
                    <td style="padding:0in;vertical-align:top;" align="left">
                        <p style="line-height:67.15pt;margin:0in 0in .0001pt;page-break-after:avoid;text-align:justify;text-indent:12.0pt;vertical-align:baseline;word-break:break-all;">
                            <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:75.0pt;"><strong>I</strong></span>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </figure>
</div>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>f the company or member causes damage to the other party by violating these terms and conditions, the company or member is responsible for compensating for the damage. However, this is not the case if there is no intention or negligence of the actor.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 1. The Limitation of Liability of the Company or Members for the Use of This Site.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>In the event of damage to a member due to the following reasons, the company shall not be held liable for such damage if it has been proven that the necessary manager's care was taken to prevent the member's damage from occurring.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-1. In the event of force majeure, such as natural disasters, incidents, disasters, or equivalent national emergencies</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-2. Company measures to comply with governmental administrative orders and administrative measures in accordance with the law</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-3. In case of a service failure of a telecommunications service company registered with the government</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-4. In the event of a service failure due to a defect in an outsourced system that cannot be managed by the company or a reason attributable to the user</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-5. In case of a server failure due to an instantaneous increase in traffic or a surge in orders for some items</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-6. When an error check occurs in the transaction system and deposit/withdrawal system within the service</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>1-7. In case of network failure or error of registered digital assets</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>Article 2 Duties of Company Managers</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-1. Appointment and management of information protection officer</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-2. information security education</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-3. Establishment of systems to prevent money laundering, etc.</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-4. Encryption key management plan</strong></span></span>
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    &nbsp;
</p>
<p style="line-height:107%;margin:0in 0in 8pt;text-align:justify;word-break:break-all;">
    <span style="font-family:&quot;Times New Roman&quot;, serif;font-size:12.0pt;"><span style="line-height:107%;"><strong>2-5Regular inspection of information protection measures and security incident response plans</strong></span></span>
</p></div>
            </PerfectScrollbar>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- main 끝 -->
  </div>
</template>

<style lang="scss" module>
// @import '@design';
</style>

<style>
.policy-wrap {
  padding: 40px 0;
}
.policy-wrap .el-collapse-item__header {
  padding-left: 20px;
  background-color: #f4f7ff !important;
  border-bottom: 1px solid #e9e9e9 !important;
}
.policy-wrap .scroll {
  height: 500px;
}
.policy-wrap .scroll .content {
  padding: 13px 24px 0 !important;
}
tr,
td {
  border-bottom: 1px solid #000;
}
</style>
